import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material'

import type { FlaggedSpotItem } from '../flaggedSpots'

interface FlaggedSpotsDialogProps {
  open: boolean
  /** Dialog header — the tag's display name. */
  title: string
  items: FlaggedSpotItem[]
  direction: 'ltr' | 'rtl'
  fullScreen: boolean
  onPick: (item: FlaggedSpotItem) => void
  onClose: () => void
  onGoToJournal: () => void
}

export function FlaggedSpotsDialog({
  open,
  title,
  items,
  direction,
  fullScreen,
  onPick,
  onClose,
  onGoToJournal,
}: FlaggedSpotsDialogProps) {
  const rtl = direction === 'rtl'
  const align = rtl ? 'right' : 'left'

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { direction } }}
    >
      <DialogTitle sx={{ direction, textAlign: align }}>{title}</DialogTitle>
      <DialogContent dividers sx={{ direction, p: 0 }}>
        <List disablePadding>
          {items.map((item, index) => (
            <ListItemButton
              key={`${item.filename}-${item.blockId ?? index}`}
              onClick={() => onPick(item)}
              sx={{ alignItems: 'flex-start', textAlign: align }}
            >
              <ListItemText
                sx={{ textAlign: align }}
                primary={item.title}
                primaryTypographyProps={{ sx: { fontWeight: 600 } }}
                secondaryTypographyProps={{ component: 'div' }}
                secondary={
                  <>
                    {item.context.length > 0 && (
                      <Typography
                        component="span"
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: 'block', textAlign: align }}
                      >
                        {item.context.join(' · ')}
                      </Typography>
                    )}
                    {item.snippet && (
                      <Typography
                        component="span"
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textAlign: align,
                        }}
                      >
                        {item.snippet}
                      </Typography>
                    )}
                  </>
                }
              />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions sx={{ direction, justifyContent: 'space-between' }}>
        <Button onClick={onClose} color="inherit">
          {rtl ? 'סגור' : 'Close'}
        </Button>
        <Button onClick={onGoToJournal}>{rtl ? 'לרשומון' : 'To רשומון'}</Button>
      </DialogActions>
    </Dialog>
  )
}
